<template>
  <div class="terms-follow-list" v-if="status == 'success'">
    <div class="flex mt-6 justify-between" v-for="term in terms" :key="term.id">
      <div class="w-full">
        <router-link
          :to="getLink(term)"
          class="text-sm font-bold hover:text-yka-blue"
        >
          <span class="capitalize line-clamp-2">{{ term.name }}</span>
        </router-link>
      </div>
      <div class="follow-button-wrapper">
        <FollowBtn
          :object_id="term.id"
          object_type="category"
          :follow="term.is_following"
          class="follow-button"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <div v-for="i in 5" :key="i" class="flex mt-8 items-center justify-between">
      <div class="w-full h-3 rounded-full bg-lightest-gray animate-pulse"></div>
      <div
        class="follow-button-wrapper h-9 rounded-full bg-lightest-gray animate-pulse"
      ></div>
    </div>
  </div>
</template>

<script>
import Util from "@/lib/Util";
import FollowBtn from "@/lib/FollowBtn.vue";

export default {
  name: "TermsFollowList",
  props: {
    terms: Array,
    status: String,
  },
  components: {
    FollowBtn,
  },
  setup() {
    const getLink = (term) => Util.getTermLink(term);

    return {
      getLink,
    };
  },
};
</script>
<style scoped>
.follow-button-wrapper {
  min-width: 96px;
  @apply ml-2 md:ml-4;
}

.follow-button {
  @apply text-sm p-2 px-4 rounded-full w-full bg-yka-blue border border-yka-blue text-white;
}
</style>
